import { RefObject } from "react";

type Props = {
  videoRef: RefObject<HTMLVideoElement>;
  stream: MediaStream | null;
  showFaceGuide?: boolean;
  showRec?: boolean;
  onClose?: () => void;
  placeholder?: string;
  onActivate?: () => void;
  activateLabel?: string;
};

export function IntakeCameraPreview({
  videoRef,
  stream,
  showFaceGuide = false,
  showRec = false,
  onClose,
  placeholder,
  onActivate,
  activateLabel = "CLICK HERE TO TURN ON CAMERA",
}: Props) {
  const needsActivation = !stream && onActivate;

  return (
    <div className="intake-camera-preview">
      {needsActivation ? (
        <button
          type="button"
          className="intake-camera-preview__activate"
          onClick={onActivate}
        >
          <span className="intake-camera-preview__activate-icon" aria-hidden="true">
            📷
          </span>
          <span>{activateLabel}</span>
        </button>
      ) : stream ? (
        <>
          <video
            ref={videoRef}
            className="intake-camera-preview__video"
            autoPlay
            muted
            playsInline
          />
          {showFaceGuide && (
            <div className="intake-camera-preview__face-guide" aria-hidden="true" />
          )}
          {showRec && (
            <div className="intake-camera-preview__rec">
              <span className="intake-camera-preview__rec-dot" />
            </div>
          )}
          {onClose && (
            <button
              type="button"
              className="intake-camera-preview__close"
              aria-label="Close camera preview"
              onClick={onClose}
            >
              ×
            </button>
          )}
        </>
      ) : (
        <div className="intake-camera-preview__placeholder">
          {placeholder ?? "Camera preview"}
        </div>
      )}
    </div>
  );
}
